// note to SDK team:
// using enum inside .d.ts won’t work for jest, but const enum will work.
var Role = {
  OPERATOR: 'operator',
  NONE: 'none'
};

// type getUpdateFileMessage = (
//   channel: GroupChannel | OpenChannel,
//   messageId: string | number,
//   params: FileMessageUpdateParams,
// ) => Promise<FileMessage>;

export { Role as R };